import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';

class Guest extends Component {

  Logout = () => {
    this.props.history.push('/')
  };

  render() {
    return (
      <Container className="guest">
        <h1>Guest</h1>
        <h3>ยินดีต้อนรับ</h3>
        <Button variant="primary">Edit</Button>
        <Button variant="danger" onClick={this.Logout}>
          ออกจากระบบ
        </Button>
      </Container>
    );
  }
}

export default Guest;
